<template>
    <div>
        <template v-if="ticketPrices && ticketPrices.length">               
            <li v-for="(ticket, idx) in ticketPrices" :key="idx">
                <div>票品:</div>                    
                <ul v-if="ticket">
                    <li v-if="ticket.ticketName">{{ticket.ticketName}} <span class="color-blue ML10" v-if="ticket.id">（票品id：{{ticket.id}}）</span></li>
                    <li v-if="ticket.groupId">{{`类型: ${ticket.groupId == 1 ? "普通门票" : ticket.groupId == 2 ? "车票" : "权益票"} `}}</li>					
					<li v-if="ticket.ticketType">
						<p v-if="ticket.ticketType == 1">票品类型: 电子票</p>
						<p v-if="ticket.ticketType == 2">票品类型: 实体票寄送</p>
						<p v-if="ticket.ticketType == 3">票品类型: 实体票自取</p>
						<p v-if="ticket.ticketType == 4">票品类型: 实体票自取/寄送</p>
					</li>					
                    <li v-if="ticket.memberNum">{{`可入场人数: ${ticket.memberNum}`}}</li>
                    <li v-if="ticket.status !== undefined">{{sellStatus.get(ticket.status)}}</li>
                    <li v-if="ticket.startTime">{{ `销售开始时间: ${ticket.startTime}`}}</li>
                    <li v-if="ticket.endTime">{{ `销售结束时间: ${ticket.endTime}`}}</li>
					<li v-if="ticket.buyType">{{`购票方式: ${ticket.buyType == 2 ? "下单时确权" : "下单后确权"} `}}</li>
					<li v-if="ticket.isCommonPerformerList !== undefined">
					  观演人限制:
					  <template v-if="ticket.isCommonPerformerList === 3">限制学生认证观演人</template>
					  <template v-else-if="ticket.isCommonPerformerList === 2">自定义观演人</template>
					  <template v-else-if="ticket.isCommonPerformerList === 1">仅限购票人观演</template>
					  <template v-else>不限制观演人</template>
					</li>
					<li v-if="ticket.crossAltPriceId">
					    跨票品托售:
					    <span v-if="ticket.crossAltPriceName && ticket.crossAltPriceName !=''" class="color-success">已开启 <span class="ML20 color-normal">指定托售票档:
						 {{ ticket.crossAltPriceName }}</span></span>
						<span v-else>未开启</span>						
					</li>					
					<li v-if="ticket.mailInstruction">{{`寄送票品说明: ${ticket.mailInstruction} `}}</li>
					<li v-if="ticket.pickupAddress">{{`取票地址: ${ticket.pickupAddress} `}}</li>
					<li v-if="ticket.pickupInstruction">{{`自取票品说明: ${ticket.pickupInstruction} `}}</li>
					<li v-if="ticket.pickupTimes && ticket.pickupTimes != ''"> 自取时间:{{ticket.pickupTimes[0].startTime}} 到 {{ticket.pickupTimes[0].endTime}}</li>
					<li v-if="ticket.pickupLatitude">{{`取票纬度: ${ticket.pickupLatitude} `}}</li>
					<li v-if="ticket.pickupLongitude">{{`取票纬度: ${ticket.pickupLongitude} `}}</li>					
					<li v-if="ticket.realName == 1 || ticket.realName == 0 ">{{`实名验证: ${ticket.realName == 1 ? "开启" : "关闭"} `}}</li>					
                    <li v-if="ticket.validStartTime">{{ `验票有效期: ${ticket.validStartTime} 至 ${ticket.validEndTime}`}}</li>
                    <li v-if="ticket.sellPrice">{{`票品售价: ${ticket.sellPrice} `}}</li>
                    <li v-if="ticket.originalPrice">{{`票品原价: ${ticket.originalPrice} `}}</li>
                    <li v-if="ticket.totalNum">{{`票品库存: ${ticket.totalNum} `}}</li>
                    <li v-if="ticket.accountLimitNum !== undefined">{{`票品账号限购: ${ticket.accountLimitNum == 0 ? '不限购' : ticket.accountLimitNum} `}}</li>
                    <li v-if="ticket.instruction">{{`票品说明: ${ticket.instruction} `}}</li>
					<li>
						<p v-if="ticket.isHideStartDate == 0">是否展示销售时间: 展示</p>
						<p v-if="ticket.isHideStartDate == 1">是否展示销售时间: <span class="color-danger">未展示</span></p>
					</li>
                </ul>
                <span v-else>该票品已删除</span>
            </li>
        </template>
        <!-- <li v-else>
            <div class="del-activity">该场次下票品已删除</div>
        </li>  -->
    </div>
</template>

<script>
import {activityStatus} from './mixins.js'
export default {
    mixins: [activityStatus],
    props: {
        ticketPrices: {
            type: Array,
            default: ()=> []
        }
    },
	data() {
	    return {
	        pickTimestart:'',
			pickTimeend:''
	    };
	},
    computed:{
        // memberNum(){
        //     return{
        //         1: '单人',
        //         2: '双人',
        //         3: '三人',
        //         4: '四人',
        //         5: '五人',
        //         6: '六人',
        //         7: '七人',
        //         8: '八人',
        //         9: '九人',
        //         10: '十人'
        //     }
        // }
    },
	created(){
		//this.pickTimestart =  v.datetimerangeUser && v.datetimerangeUser!='' ? v.datetimerangeUser[0]:'',
	}
}
</script>

<style lang="scss" scoped>
li{
    display: flex;
    align-items: top;
    margin-bottom: 10px;
    div{
        margin-right: 10px;
        width: 100px;
        min-width: 100px;
        text-align: right;
        color: $--color-info;
    }
    ::v-deep .el-image{
        width: 200px;
        height: 200px;
    }
    &:nth-last-child(1){
        margin: 0
    }
}
</style>